// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g5Vb6ciB39UQsTTVng62{flex-direction:column;gap:32px;display:flex}.BbVK9EDs58Zvy3muWynl{border:1px solid var(--border-neutral-default);border-radius:6px;flex-direction:column;display:flex}.BbVK9EDs58Zvy3muWynl>.A6IektEcwl8lgFmvNTIl:not(:last-child){border-bottom:1px solid var(--border-neutral-default)}.oekelpOhnkUu71__vhLY{flex-direction:column;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `g5Vb6ciB39UQsTTVng62`,
	"reasonsContainer": `BbVK9EDs58Zvy3muWynl`,
	"reason": `A6IektEcwl8lgFmvNTIl`,
	"reasonsWrapper": `oekelpOhnkUu71__vhLY`
};
export default ___CSS_LOADER_EXPORT___;
